var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChargingCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 39,
    r: 39,
    fill: "#013232"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7855 47.2712L32.2145 45.7292L35.351 40.5002H27.851L33.7145 30.7292L36.2855 32.2712L33.149 37.5002H40.649L34.7855 47.2712Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 25.5H60.5V21H57.5V25.5H56V34.5H57.5V51.75C57.5 52.3467 57.2629 52.919 56.841 53.341C56.419 53.7629 55.8467 54 55.25 54C54.6533 54 54.081 53.7629 53.659 53.341C53.2371 52.919 53 52.3467 53 51.75V39C53 38.6022 52.842 38.2206 52.5607 37.9393C52.2794 37.658 51.8978 37.5 51.5 37.5H45.5V22.5C45.5 22.1022 45.342 21.7206 45.0607 21.4393C44.7794 21.158 44.3978 21 44 21H24.5C24.1022 21 23.7206 21.158 23.4393 21.4393C23.158 21.7206 23 22.1022 23 22.5V54H20V57H48.5V54H45.5V40.5H50V51.75C50 53.1424 50.5531 54.4777 51.5377 55.4623C52.5223 56.4469 53.8576 57 55.25 57C56.6424 57 57.9777 56.4469 58.9623 55.4623C59.9469 54.4777 60.5 53.1424 60.5 51.75V34.5H62V25.5ZM42.5 54H26V24H42.5V54Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargingCircle);
export default __webpack_public_path__ + "static/media/charging-circle.0c12072ae8118be79e60b9b9f992bfe3.svg";
export { ForwardRef as ReactComponent };